import { makeStyles, tokens } from "@fluentui/react-components";

export const useResetPasswordStyles = makeStyles({
  repeatPasswordIcons: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS,
  },
  passwordInfoContainer: {
    paddingLeft: "1.5rem",
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXS,
  },
  passwordsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
    marginBottom: tokens.spacingVerticalM,
  },
});
